import { render, staticRenderFns } from "./SettingDepartment.vue?vue&type=template&id=380aeb98&"
import script from "./SettingDepartment.vue?vue&type=script&lang=js&"
export * from "./SettingDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports